import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';

bootstrapApplication(App, appConfig)
  .then(() => {
    // Removing current angular version from app-root element
    const appRoot = document.querySelector('app-root');
    appRoot?.removeAttribute('ng-version');
  })
  .catch((err) => console.error(err));
